module.exports = __webpack_public_path__ + "static/media/BidConfirmed.fc804110.png";